function DeleteWorkspaceController() {
  const ctrl = this;

  ctrl.$onInit = () => {};

  ctrl.cancel = () => {
    ctrl.onCancel();
  };

  ctrl.submit = () => {
    ctrl.onSubmit({
      $event: {
        mode: ctrl.mode,
      },
    });
  };
}

angular
  .module('pis-tool.module')
  .controller('DeleteWorkspaceController', DeleteWorkspaceController);
